<template>
  <footer class="footer_nav">
    <ul>
      <li :class="{ active: 1 == getClass }" @click="callTab(1)">कॉल</li>
      <li :class="{ active: 2 == getClass }" @click="callTab(2)">हिंस्ट्री</li>
    </ul>
  </footer>
</template>
<script>
export default {
  name: "Footer",
  components: {},
  data() {
    return {
      getClass: 1
    };
  },

  computed: {},

  methods: {
    callTab(value) {
      this.$emit("CallTab", value);
      this.getClass = value;
    }
  }
};
</script>
